import { PostCommonT } from '~/state/post/_common';

import { PostableOwnerWithType, getOwner } from './getOwner';

type Option = {
  postId?: string | number;
};

export function getOwnerLink(
  maybeOwner: PostableOwnerWithType | PostCommonT,
  option: Option = {},
): string {
  const owner = 'uid' in maybeOwner ? maybeOwner : getOwner(maybeOwner);
  let href = owner.userType === 'org' ? `/orgs/${owner.uid}` : `/corps/${owner.uid}`;
  if (option.postId != null) {
    href = `${href}/${option.postId}`;
  }
  return href;
}
